:host {
  display: block;
  font-family: inherit;

  --dropdown-bg: white;
  --dropdown-border: 1px solid #e1e5e9;
  --dropdown-padding: 0.5rem 1rem;
  --dropdown-margin-bottom: 1rem;
  --dropdown-border-radius: 4px;
  --dropdown-focus-border: #007bff;
  --dropdown-focus-outline: 2px solid #007bff;
  --dropdown-disabled-opacity: 0.6;
  --loading-opacity: 0.7;
}

:host([loading]) {
  opacity: var(--loading-opacity);
}

.compact-selector {
  display: block;
  margin-bottom: var(--dropdown-margin-bottom);
}

.variant-dropdown {
  width: 100%;
  appearance: none;
  background-color: var(--dropdown-bg);
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23333' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 12px 12px;
  border: var(--dropdown-border);
  border-radius: var(--dropdown-border-radius);
  padding: var(--dropdown-padding);
  padding-right: 2.5rem;
  font-family: inherit;
  font-size: inherit;
  line-height: 1.5;
  cursor: pointer;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.variant-dropdown:hover {
  border-color: var(--dropdown-focus-border);
}

.variant-dropdown:focus {
  border-color: var(--dropdown-focus-border);
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.variant-dropdown option:disabled {
  opacity: var(--dropdown-disabled-opacity);
}
